import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import Close from "../../icons/Close";
import { yodaInfoActions } from "../../logic/actions/yodaInfo.actions";
import { stringHtmlConverter } from "../../utils/stringHtmlConverter";
const TableSize = ({ onClose }) => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const dispatch = useDispatch();
  const { sizeScale } = useSelector((state) => state.yodaInfo);

  useEffect(() => {
    dispatch(yodaInfoActions.getSizeScale());
  }, []);

  useEffect(() => {
    // FOR INSERT HTML
    const divElement = document.getElementById("idDivScalarino");
    divElement.innerHTML = "";
    divElement.appendChild(
      stringHtmlConverter(
        lang === "it"
          ? sizeScale?.content?.it || ""
          : sizeScale?.content?.en || "",
      ),
    );
  }, [sizeScale]);

  return (
    <>
      <Flex
        sx={{
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, .5)",
          zIndex: 9999,
          position: "fixed",
          top: 0,
          left: 0,
        }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Flex
          sx={{
            width: ["100%", "60%"],
            backgroundColor: "white",
            borderRadius: [0, "20px"],
            height: ["100%", "80%"],
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Flex
            sx={{
              color: "black",
              gap: "20px",
              flexDirection: "column",
            }}
          >
            <div id={"idDivScalarino"}></div>
            <Box
              onClick={() => onClose()}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                cursor: "pointer",
                zIndex: 99999,
                color: "black",
              }}
            >
              <Close />
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
export default TableSize;
